let languageCode = 'ko';
let path = '/assets/dist/audio/';
module.exports = {
	languageCode,
	endonym: '한글', // Language name in the native language
	displayValue: 'Korean', // For teachers
	raadELLPurpose:
		'인간들은 지식을 쌓기위해 단어를 이용합니다. 다음 기사들을 읽으며 본인의 지식을 쌓아보아요. 매일 읽으며 단어실력 또한 본인의 읽는 이해력도 늘려보아요. 매일 책읽기를 즐기게 되어보아요 !',
	raadELLPurposeAudio: path + 'set_the_purpose_' + languageCode + '.mp3',
	raadELLMindset:
		'다음 기사들은 지식이 풍부히 담겨있어요. 읽으면서 새로운 그리고 중요한것들을 많이 배울거에요. 읽으며 물론 모르는것도 많이 있겠죠. 그건 좋은 사인이에요! 독서는 새로운걸 배울수있는 하나의 방법이에요. 물론 이 기사들에 본인이 이미 알고있는것들이 있을수도 있어요. 그것도 좋은 사인이에요. 이미 알고 있는것들에 대해서 더 읽으면 본인의 단어지식을 늘릴수있는 좋은 기회일수도있어요. 이렇게하면 본인이 새롭고 큰 아이디어를 더 잘 이해할수있게되요. 마지막으로, 이 기사들을 읽으며 본인은 더욱 강력한 독서인이 될거에요. 연습을 하면서 독서도 더욱 오래 읽을수 있게될거에요. 좋은 독서시간!',
	raadELLMindsetAudio: path + 'ell_mindset_' + languageCode + '.mp3', //: ' [^part 2 [EDITED].wav] ',
	raadELLChooseOne: '이제 다음 기사들중 읽고 싶은 기사 하나를 고르세요.',
	raadELLChooseOneAudio: path + 'aad_instructions_' + languageCode + '.mp3', //: ' [^part 3 [EDITED].wav] ',
	raadELLBOKDirectionsLabel: '설명:', // includes colon
	raadELLBOKWrite: '기사를 읽으며 배우고 기억하고싶은것  2-3가지를 메모해요.',
	raadELLBOKWriteAudio: path + 'bok_instructions_' + languageCode + '.mp3'
};
